const formatTitle = {
  creation: 'Creation',
  changeStatusTrue: 'Inactivated',
  changeStatusFalse: 'Reactivated',
  changeMaintenanceStatusTrue: 'Return from maintenance',
  changeMaintenanceStatusFalse: 'Sent for maintenance',
  changeEquipmentModel: 'Equipment type update',
  changeCompany: 'company update',
  changeReference: 'Reference update',
  changeSerialNumber: 'Serial Number Update',
  changeDescription: 'specification update',
  changePlace: 'Site update',
  changeSite: 'Site update',
  changePhoto: 'Photo Update',
  changeBrand: 'Equipment brand update',
  changeCompanies: 'Companies Update',
  default: 'This equipment has been updated'
};

export default formatTitle;
